import { List, Map } from 'immutable';
import { getColumnDefaults } from 'components/TransactionRegister/transactionsConfig';

import type { QUICKENPreferences } from './types';

const defaultQUICKENPreferences: QUICKENPreferences = {
  transactionRegister: {
    doubleAmounts: false,
    editDownloaded: true,
    deleteDownloaded: true,  // this comes with lots of warnings, so right now default on
    autoSave: true,
    splitsInDialog: false,
    autoSearch: false,
    longCats: false,
    continuousCreate: false,
    showCurrencySymbol: false,
    wrapText: false,
    showAccountColors: false,
    showMultiEditAlert: true,
    currencySymbol: '$',
    registerComfort: 'normal',
    regFieldsSort: {
      cashFlow: List(getColumnDefaults()),
      credit: List(getColumnDefaults('credit')),
    },
  },
  calendarTransaction: {
    showTransactions: true,
    showScheduleTransactions: true,
    showDailyBalances: true,
    exceedingAmount: null,
    accountsToShow: null,
    dashboard: {
      showTransactions: true,
      showScheduleTransactions: true,
    },
  },
  accountsPrefs: null,
  ofxShadowAccountIdsSeen: [],
  accountBarBalanceType: 'today',
  accountBarShowCents: true,
  accountDrawerDefaultOpen: true,
  accountNodePrefs: Map({}),
  projectedOpen: false,
  upcomingOpen: true,
  overviewPageLayout: List(),
  qCardsOffByDefault: null,
  autoRefresh: true,
  kioskmode: false,
  dateRangeProjectedBalances: 'thirty',
  currencySymbol: '$',
  theme: null,
};

export const defaultDatasetPreferences = defaultQUICKENPreferences;

export const defaultUserPreferences = {
  webApp: {
    windowsReviewedWarningEnabled: true,
  },
};

export function regFieldsSortType(regFieldsSort, rawType) {
  const investmentTypes = ['INVESTMENT', 'BROKERAGE', 'RETIREMENT', 'OTHER_INVESTMENT'];
  const type = investmentTypes.includes(rawType) ? 'investment' : rawType?.toLowerCase();
  if (regFieldsSort && (type in regFieldsSort)) {
    return type;
  }
  return 'cashFlow';
}
